export function getTime(str, type = 'year', separation = '-') {
  if (!str) {
    return "-";
  }
  str = String(str);
  if (type == 'year') {
    return (
      str.slice(0, 4)
    );
  }else if(type == 'month'){
    return (
      str.slice(0, 4) +
      separation +
      str.slice(4, 6)
    );
  }else if(type == 'day'){
    return (
      str.slice(0, 4) +
      separation +
      str.slice(4, 6) +
      separation +
      str.slice(6, 8)
    );
  }else {
    return (
      str.slice(0, 4) +
      separation +
      str.slice(4, 6) +
      separation +
      str.slice(6, 8) +
      " " +
      str.slice(8, 10) +
      ":" +
      str.slice(10, 12)
    );
  }
}


// WEBPACK FOOTER //
// ./src/util/public.js